import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../app/lang/langs";
import styles from './Ventr.module.css';
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import deleteIcon from "../../assets/images/delete.png";
import deleteIconFocus from "../../assets/images/delete-orange.png";
import { Dropdown } from "primereact/dropdown";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { showSuccessToast, showErrorToast, safeParse } from '../../app/utils/helpers';
import { useDispatch, useSelector } from "react-redux";
import { generateInterviewPDF, getInterviews, statusOptions, updateInterview } from "./VentrSlice";
import { ConfirmModal } from "../../components/popups/ConfirmModal";
import { InputTextarea } from "primereact/inputtextarea";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import { AssetsPannel } from "../../components/inputs/AssetsPannel";
import historyIcon from "../../assets/images/historyClockIcon.png";
import historyIconFocus from "../../assets/images/historyClockIconFocus.png";
import MissionHistoryModal from "./MissionHistoryModal";
import { Steps } from "primereact/steps";
import { Menubar } from "primereact/menubar";
import { TabMenu } from "primereact/tabmenu";
import { CustomTabBar } from "../../components/inputs/CustomTabBar";

export default function InterviewModal(props) {

    let visible = props.visible;
    let interview = props.interview;
    const dispatch = useDispatch();

    const allInterviews = useSelector((state) => state.ventr.interviewsList)
    const userId = useSelector((state) => state.login.userId)
    const [historyModalVisibility, setHistoryModalVisibility] = useState(false)
    const [confirmModal, setConfirmModal] = useState(false)
    const idRole = useSelector((state) => state.login.userRoleId)

    const [selected, setSelected] = useState("DIPLOMAS")

    const [tabs, setTabs] = useState([
        { id: 'DIPLOMAS', icon: 'pi pi-file' },
        { id: 'PRE_VITAL_CAREER_PATH', icon: 'pi pi-backward' },
        { id: 'VITAL_CAREER_PATH', icon: 'pi pi-arrow-right-arrow-left' },
        { id: 'TRAINING_COMPLETED', icon: 'pi pi-bookmark-fill' },
        { id: 'PROFESSIONAL_PROJECT', icon: 'pi pi-inbox' },
        { id: 'DESIRED_TRAINING', icon: 'pi pi-bookmark' },
        { id: 'OTHER', icon: 'pi pi-bars' },
        { id: 'bilan_6ans', icon: 'pi pi-inbox', forType: '6' },
        { id: 'FIN', icon: 'pi pi-save' }
    ])

    const [interviewLocal, setInterviewLocal] = useState({
        id: null,
        id_collab: null,
        status: "",
        type: "",
        theoretical_date: "",
        planned_date: "",
        diplomas: [],
        post_experience: [],
        vital_experience: [],
        training_completed: [],
        professional_project: [{
            desired_period: "",
            reorient: "",
            location: "",
            reorient_comments: "",
            responsibility: "",
            responsibility_comments: "",
            change_mission: "",
            comments: "",
            progressQ1: "",
            progressQ2: "",
            progressQ3: ""
        }],
        desired_training: [{
            period: "",
            name: "",
            funding: "",
            comments: ""
        }],
        bilan_6ans: [{
            before_last_interview_date: "",
            last_interview_date: "",
            q1: "",
            q2: "",
            q3: "",
            q4: "",
            q5: "",
            comments: ""
        }],
        collab_comment: "",
        rh_comment: "",
        interviewed_by: ""
    })

    const yesOrNoOptions = [
        { label: "Oui", value: 'Yes' },
        { label: "Non", value: 'No' }
    ]

    const isCollab = userId == interviewLocal?.id_collab
    const isViewOnly = isCollab && interviewLocal?.status != "awaiting_completion"


    useEffect(() => {
        if (interview) {
            try {
                setInterviewLocal({
                    id: interview.id || null,
                    id_collab: interview.id_collab || null,
                    status: interview.status || "",
                    type: interview.type || "",
                    theoretical_date: interview.theoretical_date || "",
                    planned_date: interview.planned_date || "",
                    diplomas: safeParse(interview.diplomas, []),
                    post_experience: safeParse(interview.post_experience, []),
                    vital_experience: safeParse(interview.vital_experience, []),
                    training_completed: safeParse(interview.training_completed, []),
                    professional_project: safeParse(interview.professional_project, [{
                        desired_period: "",
                        reorient: "",
                        location: "",
                        reorient_comments: "",
                        responsibility: "",
                        responsibility_comments: "",
                        change_mission: "",
                        comments: "",
                        progressQ1: "",
                        progressQ2: "",
                        progressQ3: ""
                    }]),
                    desired_training: safeParse(interview.desired_training, [{
                        period: "",
                        name: "",
                        funding: "",
                        comments: ""
                    }]),
                    bilan_6ans: safeParse(interview.bilan_6ans, [{
                        before_last_interview_date: getBeforeLastInterviewDate(interview),
                        last_interview_date: getLastInterviewDate(interview),
                        q1: "",
                        q2: "",
                        q3: "",
                        q4: "",
                        q5: "",
                        comments: ""
                    }]),
                    collab_comment: interview.collab_comment || "",
                    rh_comment: interview.rh_comment || "",
                    interviewed_by: interview.interviewed_by || "",
                    assets: interview.assets || []
                })
            } catch (error) {
                console.error("Error setting interview data:", error)
            }
        } else {
            setInterviewLocal({
                id: null,
                id_collab: null,
                status: "",
                type: "",
                theoretical_date: "",
                planned_date: "",
                diplomas: [],
                post_experience: [],
                vital_experience: [],
                training_completed: [],
                professional_project: [{
                    desired_period: "",
                    reorient: "",
                    location: "",
                    reorient_comments: "",
                    responsibility: "",
                    responsibility_comments: "",
                    change_mission: "",
                    comments: "",
                    progressQ1: "",
                    progressQ2: "",
                    progressQ3: ""
                }],
                desired_training: [{
                    period: "",
                    name: "",
                    funding: "",
                    comments: ""
                }],
                bilan_6ans: [{
                    before_last_interview_date: "",
                    last_interview_date: "",
                    q1: "",
                    q2: "",
                    q3: "",
                    q4: "",
                    q5: "",
                    comments: ""
                }],
                collab_comment: "",
                rh_comment: "",
                interviewed_by: "",
                assets: []
            })
        }
    }, [interview])

    const onHide = () => {
        props.setVisible(false)
        props.setInterview(null)
        setSelected("DIPLOMAS")
    }

    const injectData = (index) => {
        switch (index) {
            case 0:
                setInterviewLocal({
                    ...interviewLocal,
                    post_experience: [...interviewLocal.post_experience, { poste: "", enterprise: "", from: "", to: "" }]
                })
                break;
            case 1:
                setInterviewLocal({
                    ...interviewLocal,
                    vital_experience: [...interviewLocal.vital_experience, { poste: "", client: "", from: "", to: "" }]
                })
                break;
            case 2:
                setInterviewLocal({
                    ...interviewLocal,
                    training_completed: [...interviewLocal.training_completed, {
                        name: "",
                        start_date: "",
                        date: "",
                        certificate_obtained: "",
                        assessment: "",
                        origin: "",
                        funding: "",
                        formation_vital: ""
                    }]
                });
                break;
            case 3:
                break;
            case 4:
                break;
            case 5:
                break;
            case 6:
                setInterviewLocal({
                    ...interviewLocal,
                    diplomas: [...interviewLocal.diplomas, { year: "", diplome: "", level: "" }]
                })
                break;
            case 7:
            default:
                break;
        }
    }

    const removeData = (index, indexToRemove) => {
        switch (index) {
            case 0:
                let updatedArray = [...interviewLocal.post_experience];
                updatedArray.splice(indexToRemove, 1);
                setInterviewLocal({ ...interviewLocal, post_experience: updatedArray });
                break;
            case 1:
                let updatedArray1 = [...interviewLocal.vital_experience];
                updatedArray1.splice(indexToRemove, 1);
                setInterviewLocal({ ...interviewLocal, vital_experience: updatedArray1 });
                break;
            case 2:
                let updatedArray2 = [...interviewLocal.training_completed];
                updatedArray2.splice(indexToRemove, 1);
                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray2 });
                break;
            case 3:
                break;
            case 4:
                break;
            case 5:
                break;
            case 6:
                let updatedArray6 = [...interviewLocal.diplomas];
                updatedArray6.splice(indexToRemove, 1);
                setInterviewLocal({ ...interviewLocal, diplomas: updatedArray6 });
                break;
            case 7:
            default:
                break;
        }
    }

    const validatFields = (e, field) => {
        if (Array.isArray(interviewLocal.assets) && interviewLocal.assets.length > 0) {
            const nextInterviewLocal = { ...interviewLocal, [field]: e.value };
            setInterviewLocal(nextInterviewLocal);
        } else {
            showErrorToast("Merci de télécharger le document d'entretien signé avant de valider.")
        }
    }

    const exportInterviewAsPdf = () => {
        if (interviewLocal.id) {
            let fileName = `${interviewLocal.id_collab}_${moment().format("YYYYMMDD_HHmmss")}.pdf`;
            if (props && props.interview) {
                fileName = `${props.interview.collab_prenom}_${props.interview.collab_nom}_${moment().format("YYYYMMDD_HHmmss")}.pdf`;
            }
            showSuccessToast("Génération du PDF en cours...");
            dispatch(generateInterviewPDF({ interviewId: interviewLocal.id, fileName: fileName }))
        }
    }

    function getBeforeLastInterviewDate(interview) {
        let date = ""
        let doneInterviews = allInterviews?.done.filter(i => i.id_collab == interview.id_collab && i.planned_date != interview.planned_date)
        if (doneInterviews && doneInterviews[1] && doneInterviews[1].planned_date) {
            date = moment(doneInterviews[1].planned_date, "YYYY-MM-DD").format("YYYY-MM-DD")
        }
        return date
    }

    function getLastInterviewDate(interview) {
        let date = ""
        let doneInterviews = allInterviews?.done.filter(i => i.id_collab == interview.id_collab && i.planned_date != interview.planned_date)
        if (doneInterviews && doneInterviews[0] && doneInterviews[0].planned_date) {
            date = moment(doneInterviews[0].planned_date, "YYYY-MM-DD").format("YYYY-MM-DD")
        }
        return date
    }

    const renderPreVitalCareerPath = () => {
        return (
            <div className="m-0 p-0">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between pe-4">
                        <h2>{Localize("PRE_VITAL_CAREER_PATH")}</h2>
                        {!isViewOnly && <ImageButton
                            onClick={() => { injectData(0) }}
                            image={addIcon}
                            imageFocus={addIconFocus}
                            active={true}
                            width={38} />}
                    </Col>
                </Row>
                <Row >
                    {interviewLocal.post_experience.length > 0 ? (
                        interviewLocal.post_experience.map((item, index) => (
                            <Row lg={12} key={"POST_EXP_" + index} className={"border-bottom border-top mb-1 cell-hover " + (index % 2 == 0 ? "cell-odd" : "")}>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='POSTE' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.poste || ""}
                                            disabled={isViewOnly}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.post_experience];
                                                updatedArray[index] = { ...updatedArray[index], poste: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, post_experience: updatedArray });
                                            }}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='COMPANY' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.enterprise || ""}
                                            disabled={isViewOnly}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.post_experience];
                                                updatedArray[index] = { ...updatedArray[index], enterprise: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, post_experience: updatedArray });
                                            }}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='START_DATE' /><span style={{ color: "red" }}>*</span></label>
                                        <Calendar
                                            value={item.from ? moment(item.from, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.post_experience];
                                                updatedArray[index] = { ...updatedArray[index], from: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, post_experience: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-around py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='END_DATE' /><span style={{ color: "red" }}>*</span></label>
                                        <Calendar
                                            value={item.to ? moment(item.to, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.post_experience];
                                                updatedArray[index] = { ...updatedArray[index], to: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, post_experience: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                {isViewOnly ?
                                    <Col lg={1} md={12} xs={12}>

                                    </Col> :
                                    <Col lg={1} md={12} xs={12} className="d-flex justify-content-end py-2 pe-4">
                                        <ImageButton
                                            onClick={() => { removeData(0, index) }}
                                            image={deleteIcon}
                                            imageFocus={deleteIconFocus}
                                            active={true}
                                            width={28} />
                                    </Col>}
                            </Row>
                        ))
                    ) : (
                        <p><Langs str="Aucune donnée" /></p>
                    )}
                </Row>
            </div>
        )
    }

    const handleFinishInterview = () => {
        setConfirmModal(false)
        handleSave(interviewLocal, "awaiting_scheduling")
    }

    const renderVitalCareerPath = () => {
        return (
            <div className="m-0 p-0">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between pe-4">
                        <h2>{Localize("VITAL_CAREER_PATH")}</h2>
                        <div>
                            <ImageButton
                                onClick={() => { setHistoryModalVisibility(true) }}
                                image={historyIcon}
                                imageFocus={historyIconFocus}
                                tooltip={<Langs str="MISSION_HISTORY" />}
                                active={true}
                                width={38} />
                            {!isViewOnly && <ImageButton
                                onClick={() => { injectData(1) }}
                                image={addIcon}
                                imageFocus={addIconFocus}
                                active={true}
                                width={38} />}

                        </div>
                    </Col>
                </Row>
                <Row>
                    {interviewLocal.vital_experience.length > 0 ? (
                        interviewLocal.vital_experience.map((item, index) => (
                            <Row lg={12} key={"VITAL_EXP_" + index} className={"border-bottom border-top mb-1 cell-hover " + (index % 2 == 0 ? "cell-odd" : "")}>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='POSTE' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.poste || ""}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.vital_experience];
                                                updatedArray[index] = { ...updatedArray[index], poste: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, vital_experience: updatedArray });
                                            }}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='CLIENT' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.client || ""}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.vital_experience];
                                                updatedArray[index] = { ...updatedArray[index], client: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, vital_experience: updatedArray });
                                            }}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='START_DATE' /><span style={{ color: "red" }}>*</span></label>
                                        <Calendar
                                            value={item.from ? moment(item.from, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.vital_experience];
                                                updatedArray[index] = { ...updatedArray[index], from: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, vital_experience: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-around py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='END_DATE' /></label>
                                        <Calendar
                                            value={item.to ? moment(item.to, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.vital_experience];
                                                updatedArray[index] = { ...updatedArray[index], to: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, vital_experience: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={1} md={12} xs={12} className="d-flex justify-content-end py-2 pe-4">
                                    {!isViewOnly && <ImageButton
                                        onClick={() => { removeData(1, index) }}
                                        image={deleteIcon}
                                        imageFocus={deleteIconFocus}
                                        active={true}
                                        width={28} />}

                                </Col>
                            </Row>
                        ))
                    ) : (
                        <p><Langs str="Aucune donnée" /></p>
                    )}
                </Row>
            </div>
        )
    }

    const renderTrainingCompleted = () => {
        const fundingOptions = [
            { label: "CPF", value: "CPF" },
            { label: "Employeur", value: "Employeur" },
            { label: "Autofinancé", value: "Autofinancé" },
            { label: "Autre", value: "Autre" }
        ]
        const originsOptions = [
            { label: "Employeur", value: "Employeur" },
            { label: "Salarié", value: "Salarié" }
        ]

        return (
            <div className="m-0 p-0">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between pe-4">
                        <h2>{Localize("TRAINING_COMPLETED")}</h2>
                        {!isViewOnly && <ImageButton
                            onClick={() => { injectData(2) }}
                            image={addIcon}
                            imageFocus={addIconFocus}
                            active={true}
                            width={38} />}

                    </Col>
                </Row>
                <Row>
                    {interviewLocal && interviewLocal.training_completed && interviewLocal.training_completed.length > 0 ? (
                        interviewLocal.training_completed.map((item, index) => (
                            <Row key={"TRAINING_" + index} className={"border-bottom border-top mb-1 cell-hover " + (index % 2 == 0 ? "cell-odd" : "")}>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label><Langs str='NAME_NAME' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.name || ""}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], name: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='START_DATE' /><span style={{ color: "red" }}>*</span></label>
                                        <Calendar
                                            value={item.start_date ? moment(item.start_date, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], start_date: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='END_DATE' /><span style={{ color: "red" }}>*</span></label>
                                        <Calendar
                                            value={item.date ? moment(item.date, "YYYY-MM-DD").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], date: moment(e.value).format("YYYY-MM-DD") };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            dateFormat="dd-mm-yy"
                                            placeholder={Localize("dd-mm-yy")}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='ORIGIN_TRAINING' /><span style={{ color: "red" }}>*</span></label>
                                        <Dropdown
                                            value={item.origin || ""}
                                            options={originsOptions}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], origin: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            placeholder="Select"
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='FUNDING' /><span style={{ color: "red" }}>*</span></label>
                                        <Dropdown
                                            value={item.funding || ""}
                                            options={fundingOptions}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], funding: e.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            placeholder="Select"
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={2} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='CERTIFICATE_OBTAINED' /><span style={{ color: "red" }}>*</span></label>
                                        <Dropdown
                                            value={item.certificate_obtained || ""}
                                            options={yesOrNoOptions}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], certificate_obtained: e.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            placeholder="Select"
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-start p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='FORMATION_SUIVIE_VITAL' /><span style={{ color: "red" }}>*</span></label>
                                        <Dropdown
                                            value={item.formation_vital || ""}
                                            options={yesOrNoOptions}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], formation_vital: e.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            placeholder="Select"
                                            disabled={isViewOnly}
                                        />
                                    </Row>

                                </Col>
                                <Col lg={4} md={6} xs={12} className="d-flex justify-content-start border-end p-1">
                                    <Row className="w-100">
                                        <label className="my-auto m-2"><Langs str='ASSESSMENT' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            value={item.assessment || ""}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.training_completed];
                                                updatedArray[index] = { ...updatedArray[index], assessment: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, training_completed: updatedArray });
                                            }}
                                            disabled={isViewOnly}
                                        />
                                    </Row>

                                </Col>
                                <Col lg={3} md={12} className="d-flex justify-content-end p-2">
                                    {!isViewOnly && <ImageButton
                                        onClick={() => { removeData(2, index) }}
                                        image={deleteIcon}
                                        imageFocus={deleteIconFocus}
                                        active={true}
                                        width={28} />}

                                </Col>
                            </Row>
                        ))
                    ) : (
                        <p><Langs str="Aucune donnée" /></p>
                    )}
                </Row>
            </div>
        )
    }

    const renderProfessionalProject = () => {

        const locationsOptions = [
            { label: "Non", value: 'No' },
            { label: "La garenne colombes (92)", value: 'La garenne colombes (92)' },
            { label: "Mérignac (33)", value: 'Mérignac (33)' },
            { label: "Beyrouth", value: 'Beyrouth' },
            { label: "Ile Maurice", value: 'Ile Maurice' }
        ]

        return (
            <Row>
                <Col md={6} className="cell-odd p-2">
                    <Row className="py-2 px-0">
                        <Col lg={12} className="d-flex justify-content-between p-2">
                            <h2>{Localize("PROFESSIONAL_PROJECT")}</h2>
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str='SPECIFY_LOCATION_LABEL' /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2 ">
                            <Dropdown
                                className="w-75"
                                value={interviewLocal.professional_project[0]?.location || ""}
                                options={locationsOptions}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], location: e.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                placeholder={Localize('Select or enter text')}
                                disabled={isViewOnly}
                                editable
                            />

                        </Col>
                    </Row>
                    <Row className="py-2">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto w-25"><Langs str='DESIRED_PERIOD' /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <InputText
                                className="w-50 me-2"
                                value={interviewLocal.professional_project[0]?.desired_period || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], desired_period: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str='REORIENT_LABEL' /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <Dropdown
                                value={interviewLocal.professional_project[0]?.reorient || ""}
                                options={yesOrNoOptions}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], reorient: e.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                placeholder="Select"
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="Comments" /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={3}
                                className="w-75"
                                value={interviewLocal.professional_project[0]?.reorient_comments || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], reorient_comments: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str='RESPONSIBILITY_LABEL' /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <Dropdown
                                value={interviewLocal.professional_project[0]?.responsibility || ""}
                                options={yesOrNoOptions}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], responsibility: e.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                placeholder="Select"
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="Comments" /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={3}
                                className="w-75"
                                value={interviewLocal.professional_project[0]?.responsibility_comments || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], responsibility_comments: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str='CHANGE_FUNCTION_LABEL' /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <Dropdown
                                value={interviewLocal.professional_project[0]?.change_mission || ""}
                                options={yesOrNoOptions}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], change_mission: e.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                placeholder="Select"
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="px-0">
                        <Col xs={4} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="Comments" /></label>
                        </Col>
                        <Col xs={8} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={3}
                                className="w-75"
                                value={interviewLocal.professional_project[0]?.comments || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], comments: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={6} className="cell-odd p-2">
                    <Row className="py-2 px-0">
                        <Col lg={12} className="d-flex justify-content-between p-2">
                            <h2><Langs str="PROGRESSION_DEPUIS_DERNIER_ENTRETIEN" /></h2>
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="PROGRESSION_DEPUIS_DERNIER_ENTRETIEN_Q1" /></label>
                        </Col>
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={4}
                                value={interviewLocal.professional_project[0]?.progressQ1 || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], progressQ1: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="PROGRESSION_DEPUIS_DERNIER_ENTRETIEN_Q2" /></label>
                        </Col>
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={4}
                                value={interviewLocal.professional_project[0]?.progressQ2 || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], progressQ2: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                    <Row className="py-2 px-0">
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <label className="my-auto"><Langs str="PROGRESSION_DEPUIS_DERNIER_ENTRETIEN_Q3" /></label>
                        </Col>
                        <Col md={12} className="d-flex justify-content-start p-2">
                            <InputTextarea
                                rows={4}
                                value={interviewLocal.professional_project[0]?.progressQ3 || ""}
                                onChange={(e) => {
                                    let updatedProject = [...interviewLocal.professional_project];
                                    updatedProject[0] = { ...updatedProject[0], progressQ3: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, professional_project: updatedProject });
                                }}
                                disabled={isViewOnly}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    const renderDesiredTraining = () => {
        const fundingOptions = [
            { label: "CPF", value: "CPF" },
            { label: "Employeur", value: "Employeur" },
            { label: "Autofinancé", value: "Autofinancé" },
            { label: "Autre", value: "Autre" }
        ]

        return (
            <div className="m-0 p-2 cell-odd">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between p-2">
                        <h2>{Localize("DESIRED_TRAINING")}</h2>
                    </Col>
                </Row>
                <Row className="py-2 px-0">
                    <Col xs={2} className="d-flex justify-content-start py-2 p-2">
                        <label className="my-auto px-auto"><Langs str='DESIRED_PERIOD' /></label>
                    </Col>
                    <Col xs={10} className="d-flex justify-content-start py-2 p-2">
                        <InputText
                            className="w-75 pe-2"
                            value={interviewLocal.desired_training[0]?.period || ""}
                            onChange={(e) => {
                                let updatedTraining = [...interviewLocal.desired_training];
                                updatedTraining[0] = { ...updatedTraining[0], period: e.target.value };
                                setInterviewLocal({ ...interviewLocal, desired_training: updatedTraining });
                            }}
                            disabled={isViewOnly}
                        />
                    </Col>
                </Row>
                <Row className="py-2 px-0">

                    <Col xs={2} className="d-flex justify-content-start py-2 p-2">
                        <label className="my-auto px-auto"><Langs str='NAME_NAME' /></label>
                    </Col>
                    <Col xs={10} className="d-flex justify-content-start py-2 p-2">
                        <InputText
                            className="w-75 pe-2"
                            value={interviewLocal.desired_training[0]?.name || ""}
                            onChange={(e) => {
                                let updatedTraining = [...interviewLocal.desired_training];
                                updatedTraining[0] = { ...updatedTraining[0], name: e.target.value };
                                setInterviewLocal({ ...interviewLocal, desired_training: updatedTraining });
                            }}
                            disabled={isViewOnly}
                        />
                    </Col>
                </Row>
                <Row className="py-2 px-0">

                    <Col xs={2} className="d-flex justify-content-start py-2 p-2">
                        <label className="my-auto px-auto"><Langs str='FUNDING' /></label>
                    </Col>
                    <Col xs={10} className="d-flex justify-content-start py-2 p-2">
                        <Dropdown
                            value={interviewLocal.desired_training[0]?.funding || ""}
                            options={fundingOptions}
                            onChange={(e) => {
                                let updatedTraining = [...interviewLocal.desired_training];
                                updatedTraining[0] = { ...updatedTraining[0], funding: e.value };
                                setInterviewLocal({ ...interviewLocal, desired_training: updatedTraining });
                            }}
                            placeholder="Select"
                            disabled={isViewOnly}
                        />
                    </Col>
                </Row>
                <Row className="py-2 px-0">

                    <Col xs={2} className="d-flex justify-content-start py-2 p-2">
                        <label className="my-auto w-25"><Langs str="Comments" /></label>
                    </Col>
                    <Col xs={10} className="d-flex justify-content-start py-2 p-2">
                        <InputTextarea
                            rows={4}
                            className="w-75 me-2"
                            value={interviewLocal.desired_training[0]?.comments || ""}
                            onChange={(e) => {
                                let updatedTraining = [...interviewLocal.desired_training];
                                updatedTraining[0] = { ...updatedTraining[0], comments: e.target.value };
                                setInterviewLocal({ ...interviewLocal, desired_training: updatedTraining });
                            }}
                            disabled={isViewOnly}
                        />
                    </Col>
                </Row>
            </div >
        )
    }

    const renderDiplomas = () => {
        const levelOptions = [
            { label: "BAC +2", value: "BAC+2" },
            { label: "BAC +3", value: "BAC+3" },
            { label: "BAC +4", value: "BAC+4" },
            { label: "BAC +5", value: "BAC+5" },
            { label: "BAC +8", value: "BAC+8" },
            { label: "Autre", value: "Autre" }
        ]

        return (
            <div className="m-0 p-0" key={"DIPLOMES"}>
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between pe-4">
                        <h2>{Localize("DIPLOMAS")}</h2>
                        {!isViewOnly && <ImageButton
                            onClick={() => { injectData(6) }}
                            image={addIcon}
                            imageFocus={addIconFocus}
                            active={true}
                            width={38} />}

                    </Col>
                </Row>
                <Row>
                    {interviewLocal && interviewLocal.diplomas && interviewLocal.diplomas.length > 0 ?
                        interviewLocal.diplomas.map((item, index) => (
                            <Row lg={12} key={"DIPLOME_" + index} className={"border-bottom border-top mb-1 cell-hover " + (index % 2 == 0 ? "cell-odd" : "")}>
                                <Col lg={3} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto px-auto"><Langs str='YEAR' /><span style={{ color: "red" }}>*</span>
                                        </label>
                                        <Calendar
                                            className="w-75"
                                            value={item.year ? moment(item.year, "YYYY").toDate() : null}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.diplomas];
                                                updatedArray[index] = { ...updatedArray[index], year: moment(e.value).format("YYYY") };
                                                setInterviewLocal({ ...interviewLocal, diplomas: updatedArray });
                                            }}
                                            view="year"
                                            dateFormat="yy"
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={4} md={6} xs={12} className="d-flex justify-content-around border-end py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto px-auto"><Langs str='DIPLOME' /><span style={{ color: "red" }}>*</span></label>
                                        <InputText
                                            className="w-75"
                                            value={item.diplome || ""}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.diplomas];
                                                updatedArray[index] = { ...updatedArray[index], diplome: e.target.value };
                                                setInterviewLocal({ ...interviewLocal, diplomas: updatedArray });
                                            }}
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={4} md={6} xs={12} className="d-flex justify-content-around py-2 p-1">
                                    <Row className="w-100">
                                        <label className="my-auto"><Langs str='EDUCATION_LEVEL' /><span style={{ color: "red" }}>*</span></label>
                                        <Dropdown
                                            className="w-50"
                                            value={item.level || ""}
                                            options={levelOptions}
                                            onChange={(e) => {
                                                let updatedArray = [...interviewLocal.diplomas];
                                                updatedArray[index] = { ...updatedArray[index], level: e.value };
                                                setInterviewLocal({ ...interviewLocal, diplomas: updatedArray });
                                            }}
                                            placeholder="Select"
                                            disabled={isViewOnly}
                                        />
                                    </Row>
                                </Col>
                                <Col lg={1} md={6} xs={12} className="d-flex justify-content-end py-2">
                                    {!isViewOnly && <ImageButton
                                        onClick={() => { removeData(6, index) }}
                                        image={deleteIcon}
                                        imageFocus={deleteIconFocus}
                                        active={true}
                                        width={28} />}

                                </Col>
                            </Row>
                        ))
                        : <p><Langs str="Aucune donnée" /></p>
                    }
                </Row>
            </div>
        )
    }

    const renderOthers = () => {

        const typeOptions = [
            { label: "2 ans", value: "2" },
            { label: "3 ans", value: "3" },
            { label: "6 ans", value: "6" }
        ]

        return (
            <div className="m-0 p-2 cell-odd">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between p-2">
                        <h2>{Localize("OTHER")}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <Row>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str="Date d'ancienneté" /></label>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <label>{interview && interview.anciennetee_date && moment(interview.anciennetee_date).format("DD-MM-YYYY")}</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='INTERVIEW_THEORETICAL_DATE' /></label>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <Calendar
                                    value={interviewLocal.theoretical_date ? moment(interviewLocal.theoretical_date).toDate() : null}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, theoretical_date: moment(e.value).format("YYYY-MM-DD HH:mm") });
                                    }}
                                    showTime
                                    hourFormat="24"
                                    dateFormat="dd-mm-yy"
                                    placeholder={Localize("dd-mm-yy")}
                                    disabled={isCollab}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='INTERVIEW_PLANNED_DATE' /></label>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <Calendar
                                    value={interviewLocal.planned_date ? moment(interviewLocal.planned_date).toDate() : null}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, planned_date: moment(e.value).format("YYYY-MM-DD HH:mm") });
                                    }}
                                    showTime
                                    hourFormat="24"
                                    dateFormat="dd-mm-yy"
                                    placeholder={Localize("dd-mm-yy")}
                                    showButtonBar
                                    disabled={isCollab}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='TYPE' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.type || ""}
                                    options={typeOptions}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, type: e.value });
                                    }}
                                    placeholder="Select"
                                    disabled={isCollab}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

    const renderBilan6ans = () => {

        return (
            <div className="m-0 p-2 cell-odd">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between p-2">
                        <h2>{Localize("bilan_6ans")}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <Row>
                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='before_last_interview_date' /></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Calendar
                                    value={interviewLocal.bilan_6ans[0]?.before_last_interview_date && moment(interviewLocal.bilan_6ans[0]?.before_last_interview_date, "YYYY-MM-DD").toDate()}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], before_last_interview_date: moment(e.value).format("YYYY-MM-DD") };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    dateFormat="dd-mm-yy"
                                    placeholder={Localize("dd-mm-yy")}
                                    showButtonBar
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Row>
                                <Col lg={8} className="d-flex justify-content-between p-2">
                                    <label className="my-auto"><Langs str='last_interview_date' /></label>
                                </Col>
                                <Col lg={4} className="d-flex justify-content-between p-2">
                                    <Calendar
                                        value={interviewLocal.bilan_6ans[0]?.last_interview_date && moment(interviewLocal.bilan_6ans[0]?.last_interview_date, "YYYY-MM-DD").toDate()}
                                        onChange={(e) => {
                                            let updatedArray = [...interviewLocal.bilan_6ans];
                                            updatedArray[0] = { ...updatedArray[0], last_interview_date: moment(e.value).format("YYYY-MM-DD") };
                                            setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                        }}
                                        dateFormat="dd-mm-yy"
                                        placeholder={Localize("dd-mm-yy")}
                                        showButtonBar
                                        disabled={isViewOnly}
                                    />
                                </Col>
                            </Row>

                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='bilan_6ans_q1' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.bilan_6ans[0]?.q1 || ""}
                                    options={yesOrNoOptions}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], q1: e.value };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    placeholder="Select"
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='bilan_6ans_q2' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.bilan_6ans[0]?.q2 || ""}
                                    options={yesOrNoOptions}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], q2: e.value };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    placeholder="Select"
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='bilan_6ans_q3' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.bilan_6ans[0]?.q3 || ""}
                                    options={yesOrNoOptions}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], q3: e.value };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    placeholder="Select"
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='bilan_6ans_q4' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.bilan_6ans[0]?.q4 || ""}
                                    options={yesOrNoOptions}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], q4: e.value };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    placeholder="Select"
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='bilan_6ans_q5' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <Col lg={4} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.bilan_6ans[0]?.q5 || ""}
                                    options={yesOrNoOptions}
                                    onChange={(e) => {
                                        let updatedArray = [...interviewLocal.bilan_6ans];
                                        updatedArray[0] = { ...updatedArray[0], q5: e.value };
                                        setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedArray });
                                    }}
                                    placeholder="Select"
                                    disabled={isViewOnly}
                                />
                            </Col>
                        </Row>

                    </Col>
                    <Col lg={6}>
                        <Row className="d-flex justify-content-between p-2 pe-4 ps-4">
                            <Col lg={12} className="pb-3">
                                <label className="my-auto"><Langs str='bilan_comments' /><span style={{ color: "red" }}>*</span></label>
                            </Col>
                            <InputTextarea
                                rows={10}
                                value={interviewLocal.bilan_6ans[0]?.comments || ""}
                                onChange={(e) => {
                                    let updatedBilan = [...interviewLocal.bilan_6ans];
                                    updatedBilan[0] = { ...updatedBilan[0], comments: e.target.value };
                                    setInterviewLocal({ ...interviewLocal, bilan_6ans: updatedBilan });
                                }}
                                disabled={isViewOnly}
                            />
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

    const renderFin = () => {

        return (
            <div className="m-0 p-2 cell-odd">
                <Row className="py-2 px-0">
                    <Col lg={12} className="d-flex justify-content-between p-2">
                        <h2>{Localize("FIN")}</h2>
                        {!isCollab && <ImageButton
                            onClick={() => { exportInterviewAsPdf() }}
                            image={exportIcon}
                            imageFocus={exportIconFocus}
                            tooltip="Export PDF"
                            active={true}
                            width={38}
                        />}
                    </Col>
                </Row>
                <Row>
                    <Col lg={8}>
                        <Row>
                            <Col lg={5} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='RH_COMMENT' /></label>
                            </Col>
                            <Col lg={7} className="d-flex justify-content-between p-2">
                                <InputTextarea
                                    rows={4}
                                    className="w-75 pe-4"
                                    value={interviewLocal.rh_comment || ""}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, rh_comment: e.target.value })
                                    }}
                                    disabled={isCollab}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={5} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='COLLAB_COMMENT' /></label>
                            </Col>
                            <Col lg={7} className="d-flex justify-content-between p-2">
                                <InputTextarea
                                    rows={4}
                                    className="w-75 pe-4"
                                    value={interviewLocal.collab_comment || ""}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, collab_comment: e.target.value });
                                    }}
                                    disabled={isViewOnly}
                                />
                            </Col>

                        </Row>
                        <Row className="pb-4">
                            <Col lg={5} className="d-flex justify-content-between p-2">
                                <label className="my-auto"><Langs str='INTERVIEWED_BY' /></label>
                            </Col>
                            <Col lg={7} className="d-flex justify-content-between p-2">
                                <InputText
                                    className="w-75 pe-4"
                                    value={interviewLocal.interviewed_by || ""}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, interviewed_by: e.target.value });
                                    }}
                                    disabled={isCollab}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={5} className="d-flex justify-content-between p-2">
                                <strong><Langs str='Status' /></strong>
                            </Col>
                            <Col lg={7} className="d-flex justify-content-between p-2">
                                <Dropdown
                                    value={interviewLocal.status}
                                    options={statusOptions}
                                    onChange={(e) => {
                                        setInterviewLocal({ ...interviewLocal, status: e.value })
                                    }}
                                    placeholder="Select"
                                    disabled={isCollab}
                                    valueTemplate={(option) => <span style={{ color: option.color }}>{option.label}</span>}
                                    itemTemplate={(option) => <span style={{ color: option.color }}>{option.label}</span>}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={4} className="px-2">
                        <AssetsPannel
                            tableName='interviews'
                            idParent={interviewLocal?.id}
                            assets={interviewLocal?.assets}
                            uploadCallBackFunction={() => { }}
                            deleteCallBackFunction={() => { }}
                            label="Signed files"
                            readOnly={isCollab}
                            limitLength={10}
                            parentSetter={setInterviewLocal}
                        />
                    </Col>
                </Row>
            </div>
        )
    }

    let activeTabs = tabs.filter(t => !t.forType || (interviewLocal && interviewLocal.type == t.forType))

    const renderSelectedTab = () => {

        let body = <div></div>
        switch (selected) {
            case "DIPLOMAS":
                body = renderDiplomas()
                break
            case "PRE_VITAL_CAREER_PATH":
                body = renderPreVitalCareerPath()
                break
            case "VITAL_CAREER_PATH":
                body = renderVitalCareerPath()
                break
            case "TRAINING_COMPLETED":
                body = renderTrainingCompleted()
                break
            case "PROFESSIONAL_PROJECT":
                body = renderProfessionalProject()
                break
            case "DESIRED_TRAINING":
                body = renderDesiredTraining()
                break
            case "OTHER":
                body = renderOthers()
                break
            case "bilan_6ans":
                body = renderBilan6ans()
                break
            case "FIN":
                body = renderFin()
                break
            default:
                break
        }

        return <div>
            <CustomTabBar items={activeTabs.map((item) => ({
                id: item.id,
                label: Localize(item.id),
                icon: item.icon
            }))}
                value={selected}
                onChange={setSelected} />
            {body}
        </div>
    }


    const handleSave = (interview, status) => {

        let mandatoryFields = {
            diplomas: [{
                year: "string",
                diplome: "string",
                level: "string"
            }],
            post_experience: [{
                from: "string",
                to: "string",
                poste: "string",
                enterprise: "string"
            }],
            vital_experience: [{
                client: "string",
                from: "string",
                poste: "string"
            }],
            training_completed: [{
                start_date: "string",
                date: "string",
                name: "string",
                certificate_obtained: "string",
                assessment: "string",
                origin: "string",
                funding: "string",
                formation_vital: "string"
            }]
        }
        if (idRole > 1 && interview.type == "6") {
            mandatoryFields.bilan_6ans = [{
                q1: "string",
                q2: "string",
                q3: "string",
                q4: "string",
                q5: "string",
                comments: "string"
            }]
        }

        const hasInvalidFields = (array, expectedStructure) => {
            return array.some(item =>
                Object.keys(expectedStructure).some(key =>
                    item[key] === "" || (typeof item[key] === "string" && item[key].trim() === "")
                )
            )
        }

        for (const key in mandatoryFields) {
            if (interview[key] && Array.isArray(interview[key]) && interview[key].length > 0) {
                let expectedStructure = mandatoryFields[key][0]
                if (hasInvalidFields(interview[key], expectedStructure)) {
                    let message = Localize("MESSAGE_INTERVIEW_MODAL") + " " + Localize(key)
                    showErrorToast(message)
                    return
                }
            }
        }

        let updatedInterviewLocal = {
            ...interviewLocal,
            theoretical_date: moment(interview.theoretical_date).format("YYYY-MM-DD HH:mm:ss"),
            planned_date: interview.planned_date && interview.planned_date.trim() != "" ? moment(interview.planned_date).format("YYYY-MM-DD HH:mm:ss") : null
        }

        if (status) {
            updatedInterviewLocal.status = status
        }

        dispatch(updateInterview({ interview: updatedInterviewLocal }))
            .then((response) => {
                const responseData = response.payload.responseData;
                if (responseData && responseData.status === 1) {
                    showSuccessToast("Entretien mise à jour avec succès.")
                    dispatch(getInterviews())
                    if (status) onHide()
                } else {
                    showErrorToast("La mise à jour de votre entretien a échoué. Veuillez compléter tous les détails puis réessayer.")
                }
            })
    }

    const modalHeader = () => {
        return (
            <Row>
                <Col lg={12} className="d-flex justify-content-start my-auto">
                    <p className="my-auto"><Langs str='INTERVIEW_WITH' /></p>
                    <p style={{ color: "green", marginLeft: "15px" }} className="my-auto">
                        {interview?.collab_nom + " " + interview?.collab_prenom}
                    </p>
                </Col>
            </Row>
        )
    }

    const modalFooter = () => {
        let tabIndex = activeTabs.findIndex(item => item.id === selected)
        let tabIds = Object.values(activeTabs).map(item => item.id)
        return (
            <Row className="d-flex justify-content-around">
                <Col lg={1} className="pb-2">
                    {tabIndex > 0 &&
                        <DynamicButton
                            onClick={() => setSelected(tabIds[tabIndex - 1])}
                            className='me-auto'
                            title={<Langs str="Previous" />}
                            active={true}
                            color="blue"
                        />
                    }
                </Col>

                {isViewOnly ?
                    <Col lg={1} className="pb-2"></Col>
                    : <Col lg={1} className="pb-2"><DynamicButton
                        onClick={() => {
                            handleSave(interviewLocal)
                        }}
                        className='me-auto'
                        title={<Langs str={"SAVE"} />}
                        active={true}
                        color={"green"}
                    /> </Col>}

                <Col lg={1} className="pb-2">
                    {tabIndex < activeTabs.length - 1 ?
                        <DynamicButton
                            onClick={() => setSelected(tabIds[tabIndex + 1])}
                            className='me-auto'
                            title={<Langs str="NEXT" />}
                            active={true}
                            color="blue"
                        />
                        :
                        (isCollab && !isViewOnly && <DynamicButton
                            onClick={() => setConfirmModal(true)}
                            className='me-auto'
                            title={<Langs str="Finish" />}
                            active={true}
                            color="red"
                        />)
                    }
                </Col>
            </Row>
        )
    }

    return (
        <div>
            <Dialog
                visible={visible}
                onHide={onHide}
                draggable={false}
                style={{ width: '100vw', height: "100vh", maxHeight: "100%", marginRight: 0 }}
                header={modalHeader()}
                footer={modalFooter()}
            >
                {renderSelectedTab()}
            </Dialog>
            <MissionHistoryModal
                visible={historyModalVisibility}
                setVisible={setHistoryModalVisibility}
                collabId={interviewLocal.id_collab}
            />
            <ConfirmModal
                show={confirmModal}
                title={<Langs str='ADD_SHIFT' />}
                message={<Langs str="CONFIRM_FINISH_INTERVIEW_MSG" />}
                onConfirm={handleFinishInterview}
                onHide={() => setConfirmModal(false)}
            />
        </div>
    )
}